import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { IUser } from '@/shared/model/user.model';
import { IAddress } from '@/shared/model/address.model';
import { IMarketer } from '@/shared/model/marketer.model';
import { IMarketerStore } from './types';

export const getters: GetterTree<IMarketerStore, RootState> = {
  getMarketer(state): IMarketer {
    return state.marketer;
  },
  getId(state): number {
    return state.marketer.id;
  },
  getBankAccountName(state): string {
    return state.marketer.bankAccountName;
  },
  getIbanNumber(state): string {
    return state.marketer.ibanNumber;
  },
  getCocRegistration(state): String {
    return state.marketer.cocRegistration;
  },
  getCocRegistrationContentType(state): String {
    return state.marketer.cocRegistrationContentType;
  },
  getUser(state): IUser {
    return state.marketer.user;
  },
  getAddress(state): IAddress {
    return state.marketer.address;
  },
  getModerator(state): IMarketer {
    return state.marketer.moderator;
  },
  getMarketers(state): IMarketer[] {
    return state.marketer.marketers;
  },
  getApproved(state): boolean {
    return state.marketer.approved;
  },
  getEnabled(state): boolean {
    return state.marketer.enabled;
  },
  getTab(state): string {
    return state.tab;
  },
  getDrawer(state): boolean {
    return state.drawer;
  },
  businessCardSimulator(state): boolean {
    return state.businessCardSimulator;
  },
};
